import React, { useContext } from "react";
import { AppContext } from "@shared/context";

import { Button } from "@components/buttons";
import HeaderItemWrapper from "./HeaderItemWrapper";

export default function HeaderMenuToggleButton() {
	const { setIsNavMenuOpen } = useContext(AppContext);

	return (
		<HeaderItemWrapper>
			<Button
				className="btn--square btn--square--sml btn--ghost"
				iconOnly
				iconClassName="u-icon--xmed u-icon--menu u-color--core--snow"
				onClick={() => setIsNavMenuOpen(true)}
			/>
		</HeaderItemWrapper>
	);
}
